import { render, staticRenderFns } from "./AgFeverChart.vue?vue&type=template&id=5552132c&"
import script from "./AgFeverChart.vue?vue&type=script&lang=js&"
export * from "./AgFeverChart.vue?vue&type=script&lang=js&"
import style0 from "./AgFeverChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports